import type { ReactNode } from 'react';

/**
 * Marka işareti: "perde köşesi" — ekran, kıvrılan perde ve oynatma üçgeni.
 *
 * Yalnız kabuk yüzeylerinde (kenar çubuğu, giriş, yükleme durumu) kullanılır;
 * her karta serpiştirilmez. Böylece imza tekrar değil, kimlik taşır.
 */
export function BrandMark({
  size = 32,
  pulse = false,
  className,
}: {
  size?: number;
  /** Yükleme durumunda marka hareketi; reduced-motion'da statik kalır. */
  pulse?: boolean;
  className?: string;
}): ReactNode {
  return (
    <span
      className={`brand-mark ${pulse ? 'brand-mark--pulse' : ''} ${className ?? ''}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 32 32" fill="none" role="img" aria-label="pbfork">
        <title>pbfork</title>
        <path d="M7 8.5h18L7 23.5z" fill="rgba(255,255,255,0.13)" />
        <path d="M25 8.5 7 23.5" stroke="rgba(255,255,255,0.55)" strokeWidth="1.2" />
        <path d="M13.5 11.5v9l8-4.5z" fill="#fff" />
        <path d="M6 26h20" stroke="rgba(255,255,255,0.52)" strokeWidth="1.5" />
      </svg>
    </span>
  );
}
